<app-header></app-header>

<div class="container-xxl">

  <section class="banner d-flex justify-content-center align-items-center text-center">
    <div class="content" data-aos="zoom-in" data-aos-duration="2000">
      <div class="title">
        <span>التعليقات</span>
      </div>
    
      <div class="links">
        <a class="text-decoration-none" href="/home"> الرئيسية </a>
        <span>/  تعليقات الطالب </span>
      </div>
    </div>
  </section>
  
  <main>
      <div class="container">        
       <div class="row d-flex justify-content-around">
        <div class="feedback d-flex justify-content-center align-items-center col-md-5"  data-aos="fade-left" data-aos-duration="2000">
         <div>
          <b>لقد انهيت الدراسة فى هذه المجموعة نطلب منك ابداء رأيك فى رحلتك الدراسية فى هذه المجموعة</b>
          <hr>
          <div>
            <div class="row">
              <div class="col-md-4">
                <label>اسم المعلم</label>
              </div>
              <div class="col-md-6">
                <b>{{teacher.userName}}</b> 
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label>اسم الدورة التدريبية</label>
              </div>
              <div class="col-md-6">
                <b>{{courseTitle}}</b> 
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label>اسم المجموعة</label>
              </div>
              <div class="col-md-6">
                <p>{{ class.Number }}</p>
              </div>
            </div>
          </div>
         </div>
        </div>
       
        <form class="col-md-5" [formGroup]="addForm" enctype="multipart/form-data"  data-aos="fade-right" data-aos-duration="2000">
           <div>
            <div class="form-group">
              <label>رأيك فى المجموعة </label>
              <input
                formControlName="message"
                [class.is-invalid]="message.invalid && message.touched"
                type="text"
                class="form-control"
              />
              <div *ngIf="message.errors && message.invalid && message.touched">
                <small class="text-danger" *ngIf="message.errors?.required">
                  الرأى مطلوب
                </small>
                <small class="text-danger" *ngIf="Title.errors.minlength">
                  اقل عدد احرف مسموح بها 3 احروف
                </small>
                <small *ngIf="Title.errors?.forbiddenName">
                  {{ Title.errors?.forbiddenName.value }} غير مسموح به
                </small>
              </div>
            </div>
      <!-- 
            <div class="form-group">
              <label>التقييم</label>
              <input
                formControlName="starsNumber"
                [class.is-invalid]="starsNumber.invalid && starsNumber.touched"
                type="text"
                class="form-control"
              />
              <div
                *ngIf="
                  starsNumber.errors && starsNumber.invalid && starsNumber.touched
                "
              >
                <small class="text-danger" *ngIf="starsNumber.errors?.required">
                  التقييم مطلوب
                </small>
              </div>
            </div>
   -->
            <div class="form-group">
              <label>التقييم</label> &nbsp;
  
              <input type="radio" name="stars" (change)="checkChanged(1,$event.target.checked)"value="1" > 1 &nbsp;
              <input type="radio" name="stars" (change)="checkChanged(2,$event.target.checked)" value="2"> 2 &nbsp;
              <input type="radio" name="stars" (change)="checkChanged(3,$event.target.checked)" value="3"> 3 &nbsp;
              <input type="radio" name="stars" (change)="checkChanged(4,$event.target.checked)"  value="4"> 4 &nbsp;
              <input type="radio" name="stars" (change)="checkChanged(5,$event.target.checked)"  value="5"> 5 &nbsp;
               
  
            </div>
                <!-- <input type="radio" *ngFor="let c of counter(5); let i = index " name="stars" value="{{i}}" >  -->
                     <!--    onchange="checkChanged(i,$event.target.checked)"> -->
      
            <input
              type="submit"
              class="submit add btn btn-light"
              value="إضافة"
              (click)="submit()"
              [disabled]="!addForm.valid"
            />
           </div>
                      
        </form>
       </div>
      </div>
    </main>
</div>

  <app-footer></app-footer>